/* eslint-disable */
import { combineReducers } from 'redux';
import Decimal from 'decimal.js-light';
import { alerts, alertShown, alertForStep } from './alertReducer';

const choices = (state = [], action) => {
  switch (action.type) {
    case 'RECEIVE_CHOICES':
      return action.choices;
    case 'POST_CHOICES':
      return state;
    default:
      return state;
  }
};

const selection = (state = [], action) => {
  switch (action.type) {
    case 'SET_SELECTION':
      return [
        ...state.filter(el => {
          if (el.productSubgroupID === action.selection.productSubgroupID) {
            if (
              el.product.id !== action.selection.product.id &&
              el.choiceID !== action.selection.choiceID
            ) {
              return el;
            }
          } else {
            return el;
          }
          return null;
        }),
        {
          productGroupID: action.selection.productGroupID,
          choiceID: action.selection.choiceID,
          product: action.selection.product,
          productSubgroupID: action.selection.productSubgroupID
        }
      ];
    case 'DELETE_SELECTION':
      return [
        ...state.filter(el => {
          if (el.productSubgroupID === action.productSubgroupID) {
            if (el.product.id !== action.productID) {
              return el;
            }
          } else {
            return el;
          }
          return null;
        })
      ];
    default:
      return state;
  }
};

const colorCanContinue = (state = [], action) => {
  switch (action.type) {
    case 'COLOR_CAN_CONTINUE':
      return action.props.length > 0;
    default:
      return state;
  }
};

const sizes = (state = [], action) => {
  switch (action.type) {
    case 'RECEIVE_SIZES':
      return action.sizes;
    default:
      return state;
  }
};

const settings = (state = {}, action) => {
  switch (action.type) {
    case 'SET_GROUP_ID':
      return {
        ...state,
        ...{
          groupID: action.groupID
        }
      };
    case 'RECEIVE_SETTINGS':
      return {
        ...state,
        ...{
          currency: action.currency,
          vat: action.vat
        }
      };
    case 'SAVE_DISCOUNT':
      return {
        ...state,
        discount: action.discount
      };
    case 'SAVE_GROUP_TYPE':
      return {
        ...state,
        groupType: action.groupType
      };
    default:
      return state;
  }
};

const gTranslations = require('./../translations/general/general_translations');

const generalTranslations = (state = {}, action) => {
  switch (action.type) {
    case 'GET_GENERAL_TRANSLATIONS': {
      const lang =
        window.config.iso_language_code !== 'de-AT'
          ? window.config.language_code
          : window.config.iso_language_code;
      return lang === 'de-AT' ? gTranslations.at : gTranslations[lang];
    }
    default:
      return state;
  }
};

const total = (state = {}, action) => {
  switch (action.type) {
    case 'CALCULATE_COLOR_SELECTION': {
      const totalColor = action.props.reduce((accumulator, currentValue) => {
        const price = new Decimal(accumulator || 0);
        const sumPrice = new Decimal(currentValue.product.unit_net_price || 0);
        return price.add(sumPrice);
      }, 0);
      const discount = action.props.reduce((accumulator, currentValue) => {
        const totalDiscount = new Decimal(accumulator || 0);
        const sumDiscount = new Decimal(
          currentValue.product.unit_discount || 0
        );
        return totalDiscount.add(sumDiscount);
      }, 0);
      return { total: totalColor, discount };
    }

    case 'CALCULATE_AMOUT_SELECTION': {
      let amountTotal = new Decimal(0);
      let amountDiscount = new Decimal(0);

      action.sizes.map(size =>
        size.products.map(product => {
          const temp = action.sizeSelections.filter(
            sizeSelection =>
              sizeSelection.productID === product.id &&
              sizeSelection.subgroupID === size.id
          );
          const unit_net_price = new Decimal(product.unit_net_price || 0);
          const unit_discount = new Decimal(product.unit_discount || 0);
          const size_total = unit_net_price.times(
            temp.reduce((sum, element) => sum + parseInt(element.amount, 10), 0)
          );
          let amount;
          if (size_total.lessThan(unit_net_price)) {
            amount = unit_net_price;
          } else {
            amount = size_total;
          }
          amountTotal = amountTotal.add(amount);

          const line_discount_total = new Decimal(
            unit_discount.times(
              temp.reduce(
                (sum, element) => sum + parseInt(element.amount, 10),
                0
              )
            ) || 0
          );
          let discount;
          if (line_discount_total.lessThan(unit_discount)) {
            discount = unit_discount;
          } else {
            discount = line_discount_total;
          }
          amountDiscount = amountDiscount.add(discount);
          return { amountTotal, amountDiscount };
        })
      );
      return { total: amountTotal, discount: amountDiscount };
    }

    case 'CALCULATE_CUSTOMIZATION_SELECTION': {
      let customizationsTotal = new Decimal(0);
      let customizationsDiscount = new Decimal(0);

      action.customizations.map(customization =>
        customization.products.map(product => {
          const o = action.costumizationToggleItems.products.find(
            item =>
              item.groupID === customization.id && item.productID === product.id
          );

          action.customizationItems
            .filter(
              toggleItem =>
                toggleItem.groupID === customization.id &&
                toggleItem.productID === product.id
            )
            .map(foundItem => {
              Object.keys(foundItem.value).map(customizationType => {
                const priceItem = product.customizations_available.find(
                  type => type.type === customizationType
                );
                const itemPrice = new Decimal(priceItem.price || 0);
                customizationsTotal = customizationsTotal.add(itemPrice);
                return customizationsTotal;
              });
              return customizationsTotal;
            });

          const sponsorPrice = product.customizations_available.find(
            sponsor_logo => sponsor_logo.type === 'sponsor_logo'
          );

          const clubLogoPrice = product.customizations_available.find(
            clubLogo => clubLogo.type === 'club_logo'
          );

          if (o) {
            if (o.sponsorLogo) {
              const price = new Decimal(sponsorPrice.price || 0).times(
                product.sizes.length
              );
              customizationsTotal = customizationsTotal.add(price);
            }
            if (o.clubLogo) {
              const price = new Decimal(clubLogoPrice.price || 0).times(
                product.sizes.length
              );
              customizationsTotal = customizationsTotal.add(price);
            }
          }

          if (action.costumizationToggleItems.unisport) {
            const unit_net_price_unisport_logo = new Decimal(
              product.unit_net_price_unisport_logo || 0
            );
            const unit_net_price = new Decimal(product.unit_net_price || 0);
            if (unit_net_price.greaterThan(unit_net_price_unisport_logo)) {
              const priceUnisportSponsor = new Decimal(
                product.unit_net_price_unisport_logo || 0
              ).times(product.sizes.length);
              customizationsTotal =
                customizationsTotal.add(priceUnisportSponsor);
              const discountUnisportSponsor = new Decimal(
                product.unit_discount_unisport_logo || 0
              ).times(product.sizes.length);
              customizationsDiscount = customizationsDiscount.add(
                discountUnisportSponsor
              );
            } else {
              const priceTotal = new Decimal(product.unit_net_price || 0).times(
                product.sizes.length
              );
              customizationsTotal = customizationsTotal.add(priceTotal);
              const discountTotal = new Decimal(
                product.unit_discount || 0
              ).times(product.sizes.length);
              customizationsDiscount =
                customizationsDiscount.add(discountTotal);
            }
          } else {
            const priceTotal = new Decimal(product.unit_net_price || 0).times(
              product.sizes.length
            );
            customizationsTotal = customizationsTotal.add(priceTotal);
            const discountTotal = new Decimal(product.unit_discount || 0).times(
              product.sizes.length
            );
            customizationsDiscount = customizationsDiscount.add(discountTotal);
          }

          return { customizationsTotal, customizationsDiscount };
        })
      );

      return { total: customizationsTotal, discount: customizationsDiscount };
    }

    case 'CALULATE_REVIEW_SELECTION':
      return state;
    default:
      return state;
  }
};

const customizations = (state = [], action) => {
  switch (action.type) {
    case 'RECIEVE_CUSTOMIZATION':
      return action.costumizations;
    case 'POST_CUSTOMIZATION':
      return state;
    default:
      return state;
  }
};

const customizationItems = (state = [], action) => {
  switch (action.type) {
    case 'COSTUMIZE_ITEM': {
      const foundIndex = state.findIndex(
        el =>
          el.productID === action.productID &&
          el.index === action.index &&
          el.groupID === action.groupID &&
          el.choicesID === action.choicesID
      );

      if (foundIndex >= 0) {
        const stateCopy = [...state];
        stateCopy[foundIndex].value = Object.assign(
          state[foundIndex].value,
          action.value
        );
        return state;
      }
      return [
        ...state.filter(
          item =>
            item.productID !== action.productID ||
            item.index !== action.index ||
            item.groupID !== action.groupID ||
            item.choicesID !== action.choicesID
        ),
        {
          groupID: action.groupID,
          index: action.index,
          value: action.value,
          productID: action.productID,
          choicesID: action.choicesID
        }
      ];
    }
    default:
      return state;
  }
};

const costumizationToggleItems = (state = {}, action) => {
  let nextToggleProducts;

  switch (action.type) {
    case 'TOGGLE_UNISPORT_LOGO':
      if (!action.toggleItem.unisport) {
        nextToggleProducts = state.products.map(product => {
          const returnVal = { ...product };
          returnVal.sponsorLogo = false;
          return returnVal;
        });
      } else {
        nextToggleProducts = state.products;
      }

      return {
        ...state,
        ...{
          unisport: !action.toggleItem.unisport,
          shouldVerifyAge: false,
          products: nextToggleProducts
        }
      };

    case 'TOGGLE_CLUB_LOGO': {
      const foundIndex = state.products.findIndex(
        item =>
          item.choicesID === action.toggleItem.choicesID &&
          item.groupID === action.toggleItem.groupID &&
          item.productID === action.toggleItem.productID
      );
      const nextValue =
        foundIndex >= 0 ? !state.products[foundIndex].clubLogo : true;
      const sponsorValue =
        foundIndex >= 0 ? state.products[foundIndex].sponsorLogo : false;
      const nextProducts = [
        ...state.products.filter(
          item =>
            item.choicesID !== action.toggleItem.choicesID ||
            item.groupID !== action.toggleItem.groupID ||
            item.productID !== action.toggleItem.productID
        ),
        {
          choicesID: action.toggleItem.choicesID,
          groupID: action.toggleItem.groupID,
          productID: action.toggleItem.productID,
          clubLogo: nextValue,
          sponsorLogo: sponsorValue
        }
      ];
      return {
        ...state,
        products: nextProducts
      };
    }

    case 'TOGGLE_SPONSOR_LOGO': {
      const foundSponsorIndex = state.products.findIndex(
        item =>
          item.choicesID === action.toggleItem.choicesID &&
          item.groupID === action.toggleItem.groupID &&
          item.productID === action.toggleItem.productID
      );
      const nextSponsorValue =
        foundSponsorIndex >= 0
          ? !state.products[foundSponsorIndex].sponsorLogo
          : true;
      const clubValue =
        foundSponsorIndex >= 0
          ? state.products[foundSponsorIndex].clubLogo
          : false;
      const nextSponsorProducts = [
        ...state.products.filter(
          item =>
            item.choicesID !== action.toggleItem.choicesID ||
            item.groupID !== action.toggleItem.groupID ||
            item.productID !== action.toggleItem.productID
        ),
        {
          choicesID: action.toggleItem.choicesID,
          groupID: action.toggleItem.groupID,
          productID: action.toggleItem.productID,
          sponsorLogo: nextSponsorValue,
          clubLogo: clubValue
        }
      ];

      if (nextSponsorValue) {
        return {
          ...state,
          ...{
            unisport: false,
            shouldVerifyAge: false,
            products: nextSponsorProducts
          }
        };
      }

      return {
        ...state,
        products: nextSponsorProducts
      };
    }

    default:
      return state;
  }
};

const cTranslations = require('./../translations/costumizations/translations');

const customizationTranslations = (state = [], action) => {
  switch (action.type) {
    case 'GET_COSTUMIZATION_TRANSLATIONS': {
      const lang =
        window.config.iso_language_code !== 'de-AT'
          ? window.config.language_code
          : window.config.iso_language_code;
      return lang === 'de-AT' ? cTranslations.at : cTranslations[lang];
    }
    default:
      return state;
  }
};

const sizeSelection = (state = [], action) => {
  switch (action.type) {
    case 'SIZE_SELECTION': {
      if (action.amount === '' || action.amount === 0) {
        return [
          ...state.filter(size => {
            if (size.subgroupID === action.subgroupID) {
              if (
                size.productID !== action.productID ||
                size.sizeID !== action.sizeID
              ) {
                return size;
              }
            } else {
              return size;
            }
            return null;
          })
        ];
      }
      const changedProduct = state.filter(size => {
        if (size.subgroupID === action.subgroupID) {
          if (
            size.choicesID === action.choicesID &&
            size.productID !== action.productID
          ) {
            return size;
          }
        } else {
          return null;
        }
        return null;
      });
      if (changedProduct.length) {
        return [
          ...state.filter(size => {
            if (size.subgroupID === action.subgroupID) {
              if (size.choicesID !== action.choicesID) {
                return size;
              }
            } else {
              return size;
            }
            return null;
          }),
          {
            productID: action.productID,
            sizeID: action.sizeID,
            amount: action.amount,
            choicesID: action.choicesID,
            inStock: action.inStock,
            subgroupID: action.subgroupID
          }
        ];
      }

      return [
        ...state.filter(size => {
          if (size.subgroupID === action.subgroupID) {
            if (
              size.productID !== action.productID ||
              size.sizeID !== action.sizeID
            ) {
              return size;
            }
          } else {
            return size;
          }
          return null;
        }),
        {
          productID: action.productID,
          sizeID: action.sizeID,
          amount: action.amount,
          choicesID: action.choicesID,
          inStock: action.inStock,
          subgroupID: action.subgroupID
        }
      ];
    }
    default:
      return state;
  }
};

const sizeCanContinue = (state = [], action) => {
  const reducer = (accumulator, currentValue) =>
    accumulator && parseInt(currentValue.amount, 10) <= currentValue.inStock;
  switch (action.type) {
    case 'SIZE_CAN_CONTINUE': {
      const canContinue = action.sizeSelections.reduce(
        reducer,
        action.sizeSelections
      );
      return canContinue;
    }
    default:
      return state;
  }
};

const review = (state = [], action) => {
  switch (action.type) {
    case 'REQUEST_REVIEW':
      return state;
    case 'RECEIVE_REVIEW':
      return action.review;
    default:
      return state;
  }
};

const rTranslations = require('./../translations/review/review_translations');

const reviewTranslations = (state = [], action) => {
  switch (action.type) {
    case 'GET_REVIEW_TRANSLATIONS': {
      const lang =
        window.config.iso_language_code !== 'de-AT'
          ? window.config.language_code
          : window.config.iso_language_code;
      return lang === 'de-AT' ? rTranslations.at : rTranslations[lang];
    }
    default:
      return state;
  }
};

const getReviewResponse = (state = [], action) => {
  switch (action.type) {
    case 'GET_REVIEW_RESPONSE':
      return action.response;
    default:
      return state;
  }
};

const isAdultProducts = (state = true, action) => {
  if (action.type === 'SET_ADULT_PRODUCTS') {
    return action.isAdult;
  }
  return state;
};

const ageConfirmed = (state = false, action) => {
  if (action.type === 'AGE_CONFIRMATION_TOGGLE') {
    return action.ageConfirmationToggle;
  }
  return state;
};

const helpShown = (state = false, action) => {
  if (action.type === 'TOGGLE_HELP') {
    return !state;
  }
  return state;
};

const reducers = combineReducers({
  settings,
  generalTranslations,
  choices,
  selection,
  colorCanContinue,
  sizes,
  sizeSelection,
  sizeCanContinue,
  customizations,
  customizationItems,
  costumizationToggleItems,
  customizationTranslations,
  review,
  reviewTranslations,
  getReviewResponse,
  total,
  alerts,
  alertShown,
  alertForStep,
  ageConfirmed,
  isAdultProducts,
  helpShown
});

export default reducers;
